import { GenericService } from "./Generic.service";

export class NavegacaoService extends GenericService<any> {
  readonly URI: string = "Navegacao";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getPainel(unidadeId: string, data: string, searchText?: string, pacienteId?: string) {
    return await super.getByResource("Painel", { UnidadeId: unidadeId, Data: data, SearchText: searchText, PacienteId: pacienteId });
  }

  public async getDetalhes(id: string) {
    return await super.getByResource(`Detalhes/${id}`);
  }

  public async adicionarAcompanhamento(body: { navegacaoId: string; tipo: number; texto: string }) {
    return await super.postByResource(body, "Acompanhamento");
  }

  public async alterarRisco(body: { navegacaoId: string; novoRisco: string }) {
    return await super.postByResource(body, "AlterarRisco");
  }

  public async registrarProximaEtapa(body: {
    navegacaoId: string;
    opcao: string;
    dataAprazamento?: string;
    turnoAprazamento?: string;
    motivoAlta?: string;
  }) {
    return await super.postByResource(body, "ProximaEtapa");
  }

  public async getAtivaPorPaciente(pacienteId: string) {
    return await super.getByResource(`AtivaPorPaciente/${pacienteId}`);
  }
}
